// extracted by mini-css-extract-plugin
module.exports = {"block":"TransferPortalNav_block__xq__a","filter":"TransferPortalNav_filter__XoaZw","active":"TransferPortalNav_active__24Bw7"};